// extracted by mini-css-extract-plugin
export default {"link":"UHBLjOZ3En-wbXF5r6XVYA=="};